<template>
  <div>
    <h5>
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <form class="pa-5">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="investigator.account.expiration_date"
            :label="$t('label.expirationDate')"
            prepend-inner-icon="event"
            readonly
            hide-details
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-divider />
      <DirectorActions v-if="isAuthorize" :object_type="object_type" />
      <SupervisorActions
        v-else
        :item="investigator"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </form>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import investigatorData from "../../../mixins/investigator_data";

export default {
  mixins: [investigatorData],
  components: { DirectorActions, SupervisorActions },
  name: "ReviewModifyExpirationDate",
  data: () => ({
    object_type: "",
    state: "",
    form_name: "",
    title: "",
    reject_comment: "",
    supervisor: ""
  }),
  created() {
    this.getData();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },
  methods: {
    getData() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/investigator/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/investigator/" +
          this.$route.params.id;
      }
      axios
        .get(path)
        .then(response => {
          this.investigator.account = response.data.data.user.account;
          this.reject_comment = response.data.reject_comment;
          this.form_name = response.data.form_name;
          this.title = response.data.title;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
          this.investigator.id = response.data.object_id;
          this.getInvestigatorName(
            this.$store.state.endpoint + "/person/" + this.investigator.id
          );
        })
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>

<style scoped></style>
